export enum HistoryContainerTypes {
  History = 'History',
  HistoryNormalization = 'HistoryNormalization',
}
